<template>
  <div>
    <span class="dropdown-span-calendar">Date:</span>
    <v-date-picker
      :input-props='{ class: "dropdown dropdown-calendar", readonly: true }'
      :formats="formats"
      v-model="day"
      :value="getDate"
      @dayclick="$emit('selectDay', $event)"
      show-caps
    />
  </div>
</template>

<script>
  import Vue from 'vue';
  import VCalendar from 'v-calendar';
  import 'v-calendar/lib/v-calendar.min.css';

  const formats = {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['L', 'YYYY-MM-DD', 'YYYY MM DD'],
    dayPopover: 'L',
    data: ['L', 'YYYY-MM-DD', 'YYYY MM DD'],
  };

  Vue.use(VCalendar, {
    firstDayOfWeek: 2, // Monday
    formats: formats,
  });

  export default {
    name: 'DateFilter',
    props: {
      date: {
        default: null
      }
    },
    data() {
      return {
        day: this.date,
        formats: formats
      };
    },
    watch: {
      date(newVal) {
        this.day = newVal != null ? new Date(newVal) : null;
      }
    },
  }
</script>
